import React from 'react';
import DocumentTitle from 'react-document-title';
import './signup.css'
export default class SignUpPage1 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.handValueChange=this.handValueChange.bind(this)
    }
    handValueChange(component,value){
        this.props.changer().handleChangeData(component,value);
        this.setState({
            component:value
        })
    }


    render() {
        return (
            <DocumentTitle title="Client Signup">
                <div className="signupcontainer">

                    <div className="imagecontainer">

                        <img src="https://client.khula.co.za/images/jalepeno.jpg" alt="" width="100%" height="auto"/>

                    </div>

                    <div className="signupcontent">

                        <h2>Register your profile</h2>

                        {/*<div className="input-container">*/}
                            {/*<div className="icon">*/}
                                {/*<img src="https://client.khula.co.za/images/farmer_signup.png" alt=""/>*/}
                            {/*</div>*/}
                            {/*<input className="input-field" type="text" placeholder="Username" onChange={(e)=>this.handValueChange('username',e.target.value)}/>*/}
                        {/*</div>*/}

                        {/*<div className="input-container">*/}
                            {/*<div className="icon">*/}
                                {/*<img src="https://client.khula.co.za/images/id-card.png" alt=""/>*/}
                            {/*</div>*/}
                            {/*<input className="input-field" type="text" placeholder="Name" onChange={(e)=>this.handValueChange('name',e.target.value)}/>*/}
                        {/*</div>*/}

                        {/*<div className="input-container">*/}
                            {/*<div className="icon">*/}
                                {/*<img src="https://client.khula.co.za/images/id-card.png" alt=""/>*/}
                            {/*</div>*/}
                            {/*<input className="input-field" type="text" placeholder="Surname" onChange={(e)=>this.handValueChange('name',e.target.value)}/>*/}
                        {/*</div>*/}

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/factory.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Company Name" onChange={(e)=>this.handValueChange('client_name',e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/gmail.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Email" onChange={(e)=>this.handValueChange('email',e.target.value)}/>
                        </div>
                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/gmail.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Phone" onChange={(e)=>this.handValueChange('phone',e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/padlock.png" alt=""/>
                            </div>
                            <input className="input-field" type="password" placeholder="Password" onChange={(e)=>this.handValueChange('password',e.target.value)}/>
                        </div>


                    </div>

                    {/*<div className="button">*/}
                        {/*<button className="signupbutton" type="button" name="button">Register</button>*/}
                    {/*</div>*/}

                </div>
            </DocumentTitle>

        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/SignUpPages/Page1.js